import { Component, OnInit } from '@angular/core';
import { EmpleadosServicio } from '../../services/empleado.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private empleadoService: EmpleadosServicio, private route: Router) {
    const token = localStorage.getItem('token');
    const ID_EMPLEADO = empleadoService.datosEmpleado.ID_EMPLEADO;

    this.empleadoService.cerrarSesion({token, ID_EMPLEADO}).subscribe( (data: any) => {
      if (data.status === 200) {
        localStorage.removeItem('token');
        this.route.navigate(['/']);
      }
    });

  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/logout/logout.component.ts